<template>
    <div>
        <transition name="fade">
          <div  v-if="loading && !errors.NO_CHART_DATA">
            <div class="prg w-14 -r-c abs .t .s w-f -z-1">
              <div class="prg-inf"></div>
            </div>
            <div class="b b-c -r-c abs .f">
              <div class="abs .f c20 o-7"></div>
              <svg class="prgc prg-inf" viewBox="0 0 38 38">
                <circle cx="50%" cy="50%" r="18"></circle>
              </svg>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="b b-c -r-c abs .f" v-if="!selectedCountry & !loading">
            <div class="abs .f c20 o-8"></div>
            <div>
              <i class="material-icons #1">show_chart</i>
              <div>{{ $t('not_specified_yet') }}</div>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="b b-c -r-c abs .f" v-if="errors.NO_CHART_DATA && selectedCountry && selectedCountry.country">
            <div class="abs .f c20 o-8"></div>
            <div>
              <i class="material-icons #1">warning</i>
              <div>{{ $t('no_data') }} {{ $t('countries')[selectedCountry.country.code.toUpperCase()] }}، {{ $t('back_later') }}</div>
            </div>
          </div>
        </transition>
        <!--
          <div class="b b-c -r-c abs .f">
            <div class="abs .f c20 o-8"></div>
            <div>
              <i class="material-icons #1">show_chart</i>
              <div>بيانات مفصلة (قريباً)</div>
            </div>
          </div>
        -->
        <LineChart :chartData="chartData" :height="300" :chartOptions="chartOptions"></LineChart>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import LineChart from '../components/LineChart'
const axios = require('axios')

export default {
  name: 'ChartWidget',
  components: {
    LineChart
  },
  computed: {
    ...mapState(['countries', 'countriesData', 'selectedCountry']),
    ...mapGetters(['getSelectedCountries'])
  },
  data () {
    return {
      errors: {
        NO_CHART_DATA: 0
      },
      loading: false,
      countryChartData: {},
      chartOptions: {},
      chartData: {}
    }
  },
  watch: {
    selectedCountry (newValue, oldValue) {
      this.getCountryChartData(newValue)
    }
  },
  methods: {
    getCountryChartData (country, loadingIndicator = true) {
      this.loading = loadingIndicator
      this.countryPanelOpen = true
      axios.get('https://api.thevirustracker.com/free-api?countryTimeline=' + country.country.code).then((resp) => {
        if (!resp.data.timelineitems || !resp.data.timelineitems[0]) {
          throw Error('No Data!')
        }
        this.errors.NO_CHART_DATA = 0

        var respData = resp.data.timelineitems[0]
        var _all = Object.entries(respData).filter(_item => _item[1].total_cases !== 0)
        var _dates = _all.map(_item => _item[0])
        var _dateData = _all.map(_item => _item[1])

        this.chartOptions = {
          title: {
            display: true,
            text: country.country.code // resp.data.countrytimelinedata[0].info.title
          }
        }
        this.chartData = {
          labels: _dates,
          datasets: [
            {
              type: 'bar',
              label: this.$t('new_daily_cases'),
              data: _dateData.map(x => x.new_daily_cases),
              backgroundColor: 'rgba(255, 152, 0, 0)',
              borderColor: 'rgba(255, 152, 0 , 1)',
              pointBackgroundColor: 'rgba(255, 152, 0 , 0.5)',
              pointHoverBackgroundColor: 'rgba(0, 0, 0 , 1)',
              pointHoverHitRadius: 12,
              pointHitRadius: 1,
              pointBorderColor: 'rgba(0, 0, 0 , 0)',
              pointBorderWidth: 10,
              borderWidth: 2
            },
            {
              type: 'bar',
              label: this.$t('new_daily_deaths'),
              data: _dateData.map(x => x.new_daily_deaths),
              backgroundColor: 'rgba(244, 67, 54, 0)',
              borderColor: 'rgba(244, 67, 54 , 1)',
              pointBackgroundColor: 'rgba(244, 67, 54 , 0.5)',
              pointHoverBackgroundColor: 'rgba(0, 0, 0 , 1)',
              pointHoverHitRadius: 12,
              pointHitRadius: 1,
              pointBorderColor: 'rgba(0, 0, 0 , 0)',
              pointBorderWidth: 10,
              borderWidth: 2
            },
            {
              label: this.$t('total_cases'),
              data: _dateData.map(x => x.total_cases),
              backgroundColor: 'rgba(255, 152, 0, 0.2)',
              borderColor: 'rgba(255, 152, 0 , 1)',
              pointBackgroundColor: 'rgba(255, 152, 0 , 0.5)',
              pointHoverBackgroundColor: 'rgba(0, 0, 0 , 1)',
              pointHoverHitRadius: 12,
              pointHitRadius: 1,
              pointBorderColor: 'rgba(0, 0, 0 , 0)',
              pointBorderWidth: 10,
              borderWidth: 1,
              lineTension: 0
            },
            {
              label: this.$t('total_recoveries'),
              data: _dateData.map(x => x.total_recoveries),
              backgroundColor: 'rgba(76, 175, 80, 0.2)',
              borderColor: 'rgba(76, 175, 80 , 1)',
              pointBackgroundColor: 'rgba(76, 175, 80 , 0.5)',
              pointHoverBackgroundColor: 'rgba(0, 0, 0 , 1)',
              pointHoverHitRadius: 12,
              pointHitRadius: 1,
              pointBorderColor: 'rgba(0, 0, 0 , 0)',
              pointBorderWidth: 10,
              borderWidth: 1,
              lineTension: 0
            },
            {
              label: this.$t('total_deaths'),
              data: _dateData.map(x => x.total_deaths),
              backgroundColor: 'rgba(244, 67, 54, 0.2)',
              borderColor: 'rgba(244, 67, 54 , 1)',
              pointBackgroundColor: 'rgba(244, 67, 54 , 0.5)',
              pointHoverBackgroundColor: 'rgba(0, 0, 0 , 1)',
              pointHoverHitRadius: 12,
              pointHitRadius: 1,
              pointBorderColor: 'rgba(0, 0, 0 , 0)',
              pointBorderWidth: 10,
              borderWidth: 1,
              lineTension: 0
            }
          ]
        }
        this.loading = false
      }).catch(error => {
        console.error(error)
        this.getCountryChartData2(country)
      })
    },
    getCountryChartData2 (country) {
      axios.get('https://corona.lmao.ninja/v2/historical/' + country.country.name_en).then((resp) => {
        var respData = resp.data.timeline
        this.chartOptions = {
          title: {
            display: true,
            text: country.country.code // resp.data.countrytimelinedata[0].info.title
          }
        }
        this.chartData = {
          labels: Object.keys(respData.cases),
          datasets: [
            {
              label: this.$t('total_cases'),
              data: Object.values(respData.cases),
              backgroundColor: 'rgba(255, 152, 0, 0.2)',
              borderColor: 'rgba(255, 152, 0 , 1)',
              pointBackgroundColor: 'rgba(255, 152, 0 , 0.5)',
              pointHoverBackgroundColor: 'rgba(0, 0, 0 , 1)',
              pointHoverHitRadius: 12,
              pointHitRadius: 1,
              pointBorderColor: 'rgba(0, 0, 0 , 0)',
              pointBorderWidth: 10,
              borderWidth: 1,
              lineTension: 0
            },
            {
              label: this.$t('total_deaths'),
              data: Object.values(respData.deaths),
              backgroundColor: 'rgba(244, 67, 54, 0.2)',
              borderColor: 'rgba(244, 67, 54 , 1)',
              pointBackgroundColor: 'rgba(244, 67, 54 , 0.5)',
              pointHoverBackgroundColor: 'rgba(0, 0, 0 , 1)',
              pointHoverHitRadius: 12,
              pointHitRadius: 1,
              pointBorderColor: 'rgba(0, 0, 0 , 0)',
              pointBorderWidth: 10,
              borderWidth: 1,
              lineTension: 0
            }
          ]
        }
        this.loading = false
      }).catch(e => { this.errors.NO_CHART_DATA = 0 })
    }
  },
  mounted () {
    setInterval(() => {
      this.getCountryChartData(this.$store.state.selectedCountry, false)
    }, 60000)
  }
}
</script>
